import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, take } from 'rxjs';
import { CommonModule } from '@angular/common';
import { EditUserComponent } from '../../components/edit-user/edit-user.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { Subscription } from 'rxjs';
import { NavbarComponent } from '../../components/navbars/navbar/navbar.component';
import { SideMenuComponent } from '../../components/navbars/side-menu/side-menu.component';
import { DataService } from '../../Services/Data Service/data.service';
import { AuthService } from '../../Auth/auth.service';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CacheService } from '../../Services/Data Service/cache.service';
import { ExcelExportService } from '../../Services/excel-export/excel-export.service';
import {
  VendorSubmission,
  VendorSubmissionsService,
} from '../../Services/vendor-submissions/vendor-submissions.service';
declare var M: any;
@Component({
  selector: 'app-vendor-management',
  standalone: true,
  imports: [NavbarComponent, CommonModule, SideMenuComponent, MatDialogModule, FormsModule, RouterModule],
  templateUrl: './vendor-management.component.html',
  styleUrl: './vendor-management.component.css'
})
export class VendorManagementComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @ViewChild(NavbarComponent) userLoader!: NavbarComponent;
  
  title = 'Vendor Management';
  exportError: string | null = null;
  exporting = false;
  loadingSubmissions = true;
  private vendorSubmissionsRows: VendorSubmission[] = [];

  selectedRecord: any;
  activeSystemCount: any;
  inactiveSystemCount: any;
  underReviewCount: any;
  vendorActionRequiredCount: any;
  selectedStatus: string = ''; // For storing the selected status
  dropdownVisible: boolean = false; // To toggle dropdown visibility

  loading: boolean = false;
  currUser: any;

  selectRecord(record: any) {
    this.selectedRecord = record;
    console.log('Selected Record:', this.selectedRecord);
  } 
  constructor(
    public dialog: MatDialog, 
    private apiService: DataService, 
    private cacheService: CacheService,
    private vendorSubmissions: VendorSubmissionsService,
    private excel: ExcelExportService,
    private cdr: ChangeDetectorRef
  ) {} 

  ngOnInit(){
    this.loadCurrUser();
    this.fetchData();
    this.excel.warmup();
    this.loadVendorSubmissionsForExport();
  };

  get exportTotalCount(): number {
    return this.vendorSubmissionsRows.length;
  }

  async downloadAll(): Promise<void> {
    this.exportError = null;
    try {
      this.exporting = true;
      this.cdr.detectChanges();
      await this.excel.exportAllVendors(this.vendorSubmissionsRows);
    } catch (err) {
      console.error('Excel export failed', err);
      this.exportError =
        this.vendorSubmissionsRows.length === 0
          ? 'No vendors to export.'
          : 'Could not download Excel file. Please try again.';
    } finally {
      this.exporting = false;
      this.cdr.detectChanges();
    }
  }

  private loadVendorSubmissionsForExport(): void {
    const cached = this.vendorSubmissions.getSnapshot();
    if (cached?.length) {
      this.vendorSubmissionsRows = cached;
      this.loadingSubmissions = false;
      this.cdr.detectChanges();
    }

    this.vendorSubmissions
      .getVendorSubmissions()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (rows) => {
          this.vendorSubmissionsRows = rows;
          this.loadingSubmissions = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.loadingSubmissions = false;
          this.cdr.detectChanges();
        },
      });
  }  

  loadCurrUser(){
      this.apiService.currentUser$.pipe(
        filter((u): u is NonNullable<typeof u> => u != null),
        take(1)
      ).subscribe({
        next: (loggedInUser) => {
          this.currUser = loggedInUser;
        },
        error: (error) => {
          console.error('Error fetching logged-in user:', error);
          this.loading = false;
        }
      });
    }
  

  trackById(index: number, account: any) {
    return account.intUserPK; // unique identifier
  }

  openDialog(rowData: any)
  { 
    document.body.style.overflow = 'hidden';
    this.dialog.open(EditUserComponent,{data:rowData})
  };

  isNavbarExpanded = false;

  toggleCollapse(expanded: boolean) {
    this.isNavbarExpanded = expanded;
  }
  data$:any;

  filteredAccounts: any[] = [];

  loadingStates = {
    company: false,
    table: false,
  };

  fetchData(): void {
    this.loadingStates.table = true;

     const cached = this.cacheService.get<any[]>('vendorAccounts');
    if (cached) {
      this.filteredAccounts = [...cached];
      this.updateActiveSystemCount();
      this.loadingStates.table = false;
      this.cdr.detectChanges();

      // Refresh in background silently
      this.refreshDataInBackground();
      return;
    }

    // If no cache, fetch fresh immediately
    this.refreshDataInBackground();
  }

  private refreshDataInBackground(): void {
    this.apiService.getUsers().subscribe({
      next: (result) => {
        // Filter vendor accounts only
        const vendorAccounts = result.filter((item: any) => item.role === 'Vendor');

        this.filteredAccounts = [...vendorAccounts];

        // Cache fresh data for 5 minutes
        this.cacheService.set('vendorAccounts', vendorAccounts, 1000 * 60 * 5);

        console.log('Vendor accounts:', this.filteredAccounts);
        this.updateActiveSystemCount();

        this.loadingStates.table = false;
      },
      error: (error) => {
        console.error('Error fetching users:', error);
        this.loadingStates.table = false;
      }
    });
  }
  
  searchText: string = '';

  // FOR SEARCH
  filterTable(): void {
    // Get vendor data from cache (or fallback to empty array)
    const allAccounts = this.cacheService.get<any[]>('vendorAccounts') || [];

    if (!this.searchText) {
      // If search box is empty, show all cached data
      this.filteredAccounts = [...allAccounts];
    } else {
      const searchTerm = this.searchText.toLowerCase();

      this.filteredAccounts = allAccounts.filter((record: any) =>
        Object.values(record).some(value =>
          value && value.toString().toLowerCase().includes(searchTerm)
        )
      );

      if (this.filteredAccounts.length) {
        this.updateActiveSystemCount();
      }
    }
  }


  //FOR ACCOUNT COUNTS:
  updateActiveSystemCount(): void {
    this.activeSystemCount = this.filteredAccounts.filter((record:any) => record.strAccountStatus === 'Approved').length,
    this.inactiveSystemCount = this.filteredAccounts.filter((record:any) => record.strAccountStatus === 'Declined').length,
    this.underReviewCount = this.filteredAccounts.filter((record:any) => record.strAccountStatus === 'Under Review').length,
    this.vendorActionRequiredCount = this.filteredAccounts.filter((record:any) => record.strAccountStatus === 'Vendor Action Required').length;
  }

  openViewForm(userId: number) {
    window.location.href= `/registrationform/${userId}`;
  }


  // FOR DROP DOWN
  toggleDropdown(): void {
    this.dropdownVisible = !this.dropdownVisible;
  }

  ngAfterViewInit(): void {
    const elems = document.querySelectorAll('.dropdown-trigger');
    M.Dropdown.init(elems, {
      constrainWidth: false,
      coverTrigger: false,
    });
  }

  filterByStatus(status: string): void {
    // Get vendor data from cache (with same key used in fetch)
    const cachedVendors = this.cacheService.get<any[]>('vendorAccounts');
    const allAccounts = cachedVendors || []; // fallback to empty array

    this.filteredAccounts = [...allAccounts]; 
    this.selectedStatus = status; 

    // Filter accounts based on the selected status
    if (status === 'Approved') {
      this.filteredAccounts = this.filteredAccounts.filter(account => account.strAccountStatus === 'Approved');
    } else if (status === 'Declined') {
      this.filteredAccounts = this.filteredAccounts.filter(account => account.strAccountStatus === 'Declined');
    } else if (status === 'Pending') {
      this.filteredAccounts = this.filteredAccounts.filter(account => ['Under Review', 'Vendor Action Required'].includes(account.strAccountStatus));
    } else if (status === 'Flagged') {
      this.filteredAccounts = this.filteredAccounts.filter(account => account.blnFlagged === true);
    } else {
      this.filteredAccounts = [...this.filteredAccounts];
    }

    this.dropdownVisible = false; 
  }

  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  sortTable(column: string): void {
    if (this.sortColumn === column) {
      // Toggle direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // New column, default to ascending
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.filteredAccounts.sort((a, b) => {
      const aValue = this.resolveValue(a, column);
      const bValue = this.resolveValue(b, column);

      if (aValue < bValue) return this.sortDirection === 'asc' ? -1 : 1;
      if (aValue > bValue) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }

  private resolveValue(obj: any, key: string): any {
    // Handle nested values (like company name)
    if (key === 'company') return obj.company?.strCompanyName?.toLowerCase() || '';
    return obj[key]?.toLowerCase?.() || obj[key] || '';
  }

  
}


